import '@isceco/widget-library2/index.js'
import '@isceco/widget-library2/core.css'
import '@isceco/widget-library2/basic-elements/ScrollTop/ScrollTop.js'
import '@isceco/widget-library2/basic-elements/Message/Message.js'
import './views/Header/Header.js'
import './views/Navigation/Navigation.js'
import './views/Status/Status.js'
import './views/Navigation/HorizontalNavigation.js'
import './views/MainView/MainView.js'
import './views/Footer/Footer.js'
import './views/Sftp/Sftp.js'

window.iscecoWidgetLibrary.languageKey = 'gasmonitoring-frontend'
window.iscecoWidgetLibrary.supportedLanguages = ['de']
window.iscecoWidgetLibrary.iconCss = 'icon.min.css'
